




































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const surveys = namespace('surveys')

@Component({
    name: "DetailSideBar",
  components: {
  }
})
export default class DetailSideBar extends Vue {
  @surveys.Getter('stateCurrentSurvey') protected stateCurrentSurvey: any

  @Prop({type: Object, default: {}}) protected question!: any
  
  typeList: any = [
    {id: 'text', text: this.$t('surveys.types.typeText')},
    {id: 'select', text: this.$t('surveys.types.typeSelect')},
  ]
  items: any =[
    { id: 'free_text_input', text: this.$t('surveys.form.text') },
    { id: 'free_number_input', text: this.$t('surveys.form.number') }
  ]
  specifyListSelect: any = [
    {id: 'single', text: this.$t('surveys.types.specifySingle')},
    {id: 'multi', text: this.$t('surveys.types.specifyMulti')}
  ]
  specifyItems: any =[
      { id: 'text', text: this.$t('surveys.form.text') },
      { id: 'number', text: this.$t('surveys.form.number') }
    ]
  isOther:boolean = false
  otherType:string = 'free_text_input'
  order:number = 0
  type:string = ''

  get questionType() {
    return this.question.type == 'text_container' ? 
         ( this.question.order == '777777777' ? 'signature' : 'comment' ) : this.question.type
  }

  @Watch('question') 
  getOther() {
    this.otherType = 'free_text_input'
    if(this.question.answers) {
      let other = this.question.answers.filter((a:any, index:number) => a.type == 'free_text_input' || a.type == 'free_number_input')
      if(other.length) this.otherType = other[0].type
      this.isOther = other.length
    }
    this.order = this.question.order
  }

  mounted() {
    if(this.question.answers) {
      let other = this.question.answers.filter((a:any, index:number) => a.type == 'free_text_input' || a.type == 'free_number_input')
      if(other.length) this.otherType = other[0].type
      this.isOther = other.length
    }
    this.order = this.question.order
  }

  changeOther() {
    if(this.isOther) {
      this.question.answers.unshift({
        order: 0, 
        type: this.otherType, 
        includeQuestions: [],
        value: ''
      })
    } else {
      this.question.answers = this.question.answers.filter((a:any) => {
        return a.type != 'free_text_input' && a.type != 'free_number_input'
      })
    }
    this.$emit('changeQuestion')
  }

  changeSpecify() {
    this.question.answerTitle = (this.question.specify == 'single') ? this.$t('surveys.form.oneAnswer') : this.$t('surveys.form.someAnswer')
    this.$emit('changeQuestion')
  }

  changeQuestionSpecify() {
    this.$emit('changeQuestion')
  }

  changeType() {
    if(this.question.type == 'text') {
      this.question.order = this.order
      this.isOther = false
      this.question.specify = 'text'
      this.question.answers = [{
        value: '',
        includeQuestions: [],
        order: 0,
        type: 'regular'
      }]
    } else {
      this.question.order = this.order
      this.question.specify = 'single '
      this.question.answers = []
    }
    this.$emit('changeQuestion')
  }

}
